// extracted by mini-css-extract-plugin
export default {"attributeEditField":"AttributeTypeEditField_attributeEditField__oAS+X","editField":"AttributeTypeEditField_editField__AoGmg"};